import React, { Component } from 'react';
export const Page = props => (
  <div className="project">

    {/* ==== EDIT BELOW THIS LINE ==== */}
    
    <h1> Branding: "Project Spark" </h1>


    <p>As the Graphics and Marketing Lead at <a href="https://www.expii.com/" target="_blank">Expii</a>, an online learning company, I was tasked with branding the new initiative "Project Spark". This initiative aims to involve more creative-minded people on our educational website, enlisting their creativity to produce varying types of explanations of lessons (such as videos, music, art, etc.)</p>

    <p>I began by designing a few different mock-ups of the poster that would be shared. The designs were to fit in with the current Expii branding identity - one that is clean and simple - but could also slightly stray from our current branding identity in the sense that this project is to attract more creativity-oriented minds. Thus, my designs ranged in feeling - from playful and creative, to modern and intriguing.</p>
    
    <div className="imgs max700">
        <div>
            <img src={require('../assets/graphicDesign/spark/inspo.png')} data-skip-gallery/>
            <p>Inspiration board</p>
        </div>
    </div>

    <div className="imgs max700">
        <div>
            <img src={require('../assets/graphicDesign/spark/mockups.png')} data-skip-gallery/>
            <p>My design mockups</p>
        </div>
    </div>

    <p>I continued going in the direction of a modern and intriguing feeling for the branding, as this fits best with the Expii brand, as well as our current goal to attract professionals within their respective creative fields. The first two designs shown above might be revisited when we begin expanding this initiative to be targeted at younger audiences, as these designs feel more playful.</p>

    <p>Given this decision, I began designing a slick and crisp branding logo for Project Spark, shown below. I still wanted to incorporate a feeling of excitement, thus I designed the sparkler text effect.</p>

    <div className="imgs max500">
        <div>
            <img src={require('../assets/graphicDesign/spark/logo.png')} data-skip-gallery/>
        </div>
    </div>

    <p>I designed the creative field icons (seen at the bottom of the below poster) in order to still maintain some of the fun aspects of my previous designs, as well as give the viewer some information about the types of content for which Project Spark is aiming. Below is my final design for the Project Spark poster.</p>

    <div className="imgs max700">
        <div>
            <img src={require('../assets/graphicDesign/spark/flyer.png')} data-skip-gallery/>
        </div>
    </div>
    
    <p>Finally, I designed the Project Spark webpage to go on Expii’s site. Using the branding identity I had just established for Project Spark, I designed a scrolling-based web page with information on what the project is, as well as how to apply.</p>

    <div className="imgs max700">
        <div>
            <img src={require('../assets/graphicDesign/spark/computerMockup.png')} data-skip-gallery/>
        </div>
    </div>

    <p>You can view the rest of this web design at <a href="https://www.expii.com/spark" target="_blank">expii.com/spark</a></p>

    <p>My next goal for this branding is to expand upon it - to add to the feeling of modernity and excitement. Possible ways to do so would include animating my sparkler texts.</p>
    {/* ==== EDIT ABOVE THIS LINE ==== */}

  </div>
)






// worked with the rabbi to developed visual 
    //symbols to represent each of the prayers in the Shabbat in order to guide the members 
    //with ASD through the ceremony. These symbols will be presented to the members via a 
    //large banner on the temple’s stage as well as on personal bookmarks that correspond 
    //with the banner. The bookmarks will also have a sticker packet with the symbols printed 
    //as stickers, to be placed on each of the corresponding sections for the current prayer 
    //on the bookmarks. The visually and physically interactive elements of these materials 
    //will help to add more sensorial aspects to the Shabbat, further benefitting Temple Sinai’s members with ASD.